import { gql } from '@apollo/client';

export const FETCH_EXPIRED = gql`
  query expiredQuery {
    request {
      id
    }
    clientSetting {
      id
      submissionDeadline {
        id
        submissionDeadlineAt
      }
    }
  }
`;
